import { Command, PriceData } from '../interfaces';

/**
 * Filter based on the price brackets. I.e treatment price is from 549 and the price bracket is [0, 100].
 * There may be more than one price bracket. Using the information above no treatments would be returned.
 * @param data a treatment
 * @returns PriceData[]
 */
export const priceFilter = <T extends PriceData>(data: T[], keys: number[][]) =>
    data.filter((element) => keys.some(([low, high]) => element.priceFrom >= low && element.priceFrom <= high));

export class PriceFilterCommand implements Command {
    isAndFilter(): boolean {
        return true;
    }

    execute(data: PriceData[], keys: number[][]) {
        return priceFilter(data, keys);
    }
}
